import { render, staticRenderFns } from "./OrderSite.vue?vue&type=template&id=64145826&scoped=true&"
import script from "./OrderSite.vue?vue&type=script&lang=js&"
export * from "./OrderSite.vue?vue&type=script&lang=js&"
import style0 from "./OrderSite.vue?vue&type=style&index=0&id=64145826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64145826",
  null
  
)

export default component.exports